"use client";
import React, { useState, useEffect, useRef } from "react";
import Image from "next/image";
import Offcanvas from "react-bootstrap/Offcanvas";
import SphericalRender from "@/components/SphericalRender";

function VirtualTourPage({images}:{images:{src:string}[]}) {
  const elementRef = useRef(null);
  const [showDrawer, setShowDrawer] = useState(true);
  const [currentScene, setCurrentScene] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [imgRowCount, setImgRowCount] = useState(6);

  // Watch for fullscreenchange
  useEffect(() => {
    function onFullscreenChange() {
      setIsFullscreen(Boolean(document.fullscreenElement));
    }

    document.addEventListener("fullscreenchange", onFullscreenChange);

    return () =>
      document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, []);

  useEffect(() => {
    if(typeof window !== "undefined")
    {
        setImgRowCount(Math.floor(window.innerHeight / 62))
    }
  }, [typeof window]);

  const onClick = (event:any) => {
    setShowDrawer(false);
    setCurrentScene(event.currentTarget.dataset["scene"]);
  };

  const handleFullscreen = () => {
    // interface Document {
    //   exitFullscreen?: () => Promise<void>;
    //   mozCancelFullScreen?: () => Promise<void>;
    //   msExitFullscreen?: () => Promise<void>;
    //   webkitExitFullscreen?: () => Promise<void>;
    //   mozFullScreenElement?: Element;
    //   msFullscreenElement?: Element;
    //   webkitFullscreenElement?: Element;
    // }
  
    // interface HTMLElement {
    //   requestFullscreen?: () => Promise<void>;
    //   msRequestFullscreen?: () => Promise<void>;
    //   mozRequestFullScreen?: () => Promise<void>;
    //   webkitRequestFullscreen?: () => Promise<void>;
    // }

    let document:any = window.document;
    let elem:any = elementRef.current; 
    if (elem) {
      if (isFullscreen) {
        setIsFullscreen(false);
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          /* Safari */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE11 */
          document.msExitFullscreen();
        }
      } else {
        setIsFullscreen(true);

        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          // For Firefox
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          // For Chrome, Safari, and Opera
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          // For IE/Edge
          elem.msRequestFullscreen();
        }
      }
    }
  };

  return (
    <div ref={elementRef}>
      <Offcanvas
        show={showDrawer}
        onHide={() => setShowDrawer(false)}
        className="bg-transparent w-auto"
      >
        <Offcanvas.Body className="bg-trans-black overflow-hidden">
          <div className="StyledDiv" style={{ gridTemplateRows: `repeat(${imgRowCount}, auto)`}} >
            {images?.map((image, idx) => (
              <button
                key={idx}
                className={`${currentScene}` === `${idx}` ? "UnstyledButton active" : "UnstyledButton "}
                onClick={onClick}
                data-scene={`${idx}`}
              >
                <Image src={image.src} width="50" height="50" alt="" />
              </button>
            ))}
          </div>
          <div className="OffcanvasButtonContainer">
            <button className="UnstyledButton" onClick={() => setShowDrawer(!showDrawer)}>
              <Image
                src={`${
                  showDrawer
                    ? "data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 18 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e"
                    : "data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 -1 14 18%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e"
                }`}
                width="50"
                height="50"
                alt=""
              />
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <div className={showDrawer ? "CanvasButtonContainer d-none" : "CanvasButtonContainer"}>
        <button className="UnstyledButton" onClick={() => setShowDrawer(!showDrawer)}>
          <Image
            src={`${
              showDrawer
                ? "data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 18 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e"
                : "data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 -1 14 18%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e"
            }`}
            width="50"
            height="50"
            alt=""
          />
        </button>
      </div>
      <div className="info-div">
        Select images from the left to view then click and drag to move around
      </div>
      <img
        onClick={handleFullscreen}
        draggable="false"
        src={
          isFullscreen
            ? "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iI0ZGRkZGRiI+CiAgICA8cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+CiAgICA8cGF0aCBkPSJNNSAxNmgzdjNoMnYtNUg1djJ6bTMtOEg1djJoNVY1SDh2M3ptNiAxMWgydi0zaDN2LTJoLTV2NXptMi0xMVY1aC0ydjVoNVY4aC0zeiIvPgo8L3N2Zz4K"
            : "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iI0ZGRkZGRiI+CiAgICA8cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+CiAgICA8cGF0aCBkPSJNNyAxNEg1djVoNXYtMkg3di0zem0tMi00aDJWN2gzVjVINXY1em0xMiA3aC0zdjJoNXYtNWgtMnYzek0xNCA1djJoM3YzaDJWNWgtNXoiLz4KPC9zdmc+Cg=="
        }
        title={isFullscreen ? "Exist fullscreen mode" : "Enter fullscreen mode"}
        style={{
          position: "absolute",
          width: "24px",
          height: "24px",
          backgroundSize: "cover",
          backgroundColor: "transparent",
          border: "0px",
          userSelect: "none",
          cursor: "pointer",
          padding: "12px",
          zIndex: "1",
          display: "block",
          boxSizing: "content-box",
          bottom: "0px",
          right: "0px",
        }}
      ></img>
      <SphericalRender background={false} image={images[currentScene].src} />
    </div>
  );
}

export default VirtualTourPage;
